<template>
  <div v-if="!isLoading" class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('advertisements.breadcrumb_1')}}</router-link></li>
            <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="almarai-bold active mx-3" aria-current="page">{{$t('advertisements.breadcrumb_2')}}</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-3">
    <div class="text-center" v-if="isLoading">
      <mainloader />
    </div>
    <div v-else class="row">
      <div class="col">
        
        <div class="row pt-3">
          <div class="col">
            <h5>{{$t('advertisements.title_1')}}</h5>
          </div>
        </div>

        <div v-if="hasError">
          <errorAlert :alertMessage="message" />
        </div>
        <div class="row pt-3">
          <div class="col-12 col-md-5 col-lg-3 mb-3" v-for="(row,index) in rows" :key="index">
            <div v-if="row.status == 'rented' || row.status == 'sold'" class="card card-border m-auto ">
              <div class="card-body position-R">
                <div class="row statusBar">
                  <div class="col-auto tag-style">
                    <span class="">{{ row.PropertyType?.name }}</span>
                  </div>
                  <div class="col-auto tag-style mx-2">
                    <span class="">{{items[row.status]}}</span>
                  </div>
                </div>
                
                <swiper v-if="row.mediaFiles.length" class="text-center"  
                  :modules="[Pagination, Navigation]" 
                  :pagination="{ clickable: true }" :navigation="false"
                >
                <swiper-slide v-for="(slide, indx) in row.mediaFiles" :key="indx">
                  <!-- <div class="dropdown position-R mouse-hand">
                    <i class="fa-solid fa-ellipsis dots-button dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"></i>
                    <ul class="dropdown-menu ads_options">
                      <router-link :to="'/propertieupdate/'+row.id">
                        <li class="dropdown-item">
                          <i class="fa-regular fa-pen-to-square"></i>
                          <span class="mx-2">{{$t('advertisements.edit')}}</span>
                        </li>
                      </router-link>
                      <li class="dropdown-item" @click.prevent="deleteImg(row.id, index)">
                        <i class="fa-regular fa-trash-can font-24 red-color"></i>
                        <span class="mx-2">{{$t('advertisements.delete')}}</span>
                      </li>
                    </ul>
                  </div> -->
                  <div v-if="row.status == 'available'" class="position-R" @click.prevent="updateStatus(row.id, row.status)">
                    <i class="fa-regular fa-pen-to-square icon_Edit"></i>
                  </div>
                  <div v-if="row.status == 'rented' || row.status == 'sold'" class="position-R" @click.prevent="updateStatus(row.id, row.status)">
                    <i class="fa-regular fa-pen-to-square icon_Edit"></i>
                  </div>
                  <div class="position-R" @click.prevent="deleteImg(row.id, index)">
                    <i class="fa-regular fa-trash-can red-color icon_Delete"></i>
                  </div>
                  

                  <img :src="MEDIA_URL+slide.thumbnail" alt="Slide Image" class="w-100 br-radius" />
                </swiper-slide>
                </swiper>
                <div v-else class="position-R">
                  <placeHolder/>
                  <!-- <div class="dropdown img-defualt mouse-hand">
                    <i class="fa-solid fa-ellipsis dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"></i>
                    <ul class="dropdown-menu ads_options">
                      <router-link :to="'/propertieupdate/'+row.id">
                        <li class="dropdown-item">
                          <i class="fa-regular fa-pen-to-square"></i>
                          <span class="mx-2">{{$t('advertisements.edit')}}</span>
                        </li>
                      </router-link>
                      <li class="dropdown-item" @click.prevent="deleteImg(row.id, index)">
                        <i class="fa-regular fa-trash-can font-24 red-color"></i>
                        <span class="mx-2">{{$t('advertisements.delete')}}</span>
                      </li>
                    </ul>
                  </div> -->
                  <!-- <div>
                    <router-link :to="'/propertieupdate/'+row.id">
                      <i class="fa-regular fa-pen-to-square icon_Edit"></i>
                    </router-link>
                  </div> -->
                  <div @click.prevent="deleteImg(row.id, index)">
                    <i class="fa-regular fa-trash-can red-color icon_Delete"></i>
                  </div>
                  
                </div>
                <div class="almarai-regular text-title">{{ row.title }}</div>
                  <div class="row pt-1">
                    <div class="col-auto px-2 content-center">
                      <i class="fa-solid fa-location-dot gray-color"></i>
                    </div>
                    <div class="col p-0 fontGray-73 content-center">
                      <div class="d-flex">
                        {{ row.City?.name }}
                        <span class="mx-1">{{ row.Neighborhood?.name }}</span>
                      </div>
                    </div>
                  </div>

                  <hr class="border-color-w">
                  <div class="row end-card space">
                    <div class="col content-center">
                      <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                      <span class="green-color-F almarai-bold">{{ row.price }}</span>
                    </div>
                    <div class="col-auto content-center" v-if="row.roomsCount && row.bathrooms">
                      <div class="row">
                        <div class="col-auto content-center">
                          <span> 
                            <img :src="MEDIA_URL + icons.roomsCount.path" 
                              class="max-width-28"
                              alt=""/>
                          </span>
                          <span class="numbers">{{ row.roomsCount }}</span>
                        </div>
                        <div class="col-auto border_Icons">
                          <span>
                            <img :src="MEDIA_URL + icons.bathrooms.path"
                              class="max-width-28"
                              alt=""/>
                          </span>
                          <span class="numbers">{{ row.bathrooms }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-else class="col-auto content-center">
                      <span>
                        <img :src="MEDIA_URL + icons.area.path"
                          class="max-width-28"
                          alt=""/>
                      </span>
                      <span class="numbers">
                        {{ row.area }}
                        <span>{{ $t("areaSymbol") }}</span>
                      </span>
                    </div>
                </div>
              </div>
            </div>
            <div v-else class="card card-border m-auto">
              <router-link :to="'/propertydetails/'+row.id+'?a=1'">
                <div class="card-body position-R">
                  <div class="row statusBar">
                    <div class="col-auto tag-style">
                      <span class="">{{ row.PropertyType?.name }}</span>
                    </div>
                    <div class="col-auto tag-style mx-2">
                      <span class="">{{items[row.status]}}</span>
                    </div>
                  </div>
                  
                  <swiper v-if="row.mediaFiles.length" class="text-center"  
                    :modules="[Pagination, Navigation]" 
                    :pagination="{ clickable: true }" :navigation="false"
                  >
                  <swiper-slide v-for="(slide, indx) in row.mediaFiles" :key="indx">
                    <!-- <div class="dropdown position-R mouse-hand">
                      <i class="fa-solid fa-ellipsis dots-button dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"></i>
                      <ul class="dropdown-menu ads_options">
                        <router-link :to="'/propertieupdate/'+row.id">
                          <li class="dropdown-item">
                            <i class="fa-regular fa-pen-to-square"></i>
                            <span class="mx-2">{{$t('advertisements.edit')}}</span>
                          </li>
                        </router-link>
                        <li class="dropdown-item" @click.prevent="deleteImg(row.id, index)">
                          <i class="fa-regular fa-trash-can font-24 red-color"></i>
                          <span class="mx-2">{{$t('advertisements.delete')}}</span>
                        </li>
                      </ul>
                    </div> -->
                    <div v-if="row.status == 'available'" class="position-R" @click.prevent="updateStatus(row.id, row.status)">
                      <i class="fa-regular fa-pen-to-square icon_Edit"></i>
                    </div>
                    <div v-if="row.status == 'rented' || row.status == 'sold'" class="position-R" @click.prevent="updateStatus(row.id, row.status)">
                      <i class="fa-regular fa-pen-to-square icon_Edit"></i>
                    </div>
                    <div class="position-R" @click.prevent="deleteImg(row.id, index)">
                      <i class="fa-regular fa-trash-can red-color icon_Delete"></i>
                    </div>
                    

                    <img :src="MEDIA_URL+slide.thumbnail" alt="Slide Image" class="w-100 br-radius" />
                  </swiper-slide>
                  </swiper>
                  <div v-else class="position-R">
                    <placeHolder/>
                    <!-- <div class="dropdown img-defualt mouse-hand">
                      <i class="fa-solid fa-ellipsis dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"></i>
                      <ul class="dropdown-menu ads_options">
                        <router-link :to="'/propertieupdate/'+row.id">
                          <li class="dropdown-item">
                            <i class="fa-regular fa-pen-to-square"></i>
                            <span class="mx-2">{{$t('advertisements.edit')}}</span>
                          </li>
                        </router-link>
                        <li class="dropdown-item" @click.prevent="deleteImg(row.id, index)">
                          <i class="fa-regular fa-trash-can font-24 red-color"></i>
                          <span class="mx-2">{{$t('advertisements.delete')}}</span>
                        </li>
                      </ul>
                    </div> -->
                    <!-- <div>
                      <router-link :to="'/propertieupdate/'+row.id">
                        <i class="fa-regular fa-pen-to-square icon_Edit"></i>
                      </router-link>
                    </div> -->
                    <div @click.prevent="deleteImg(row.id, index)">
                      <i class="fa-regular fa-trash-can red-color icon_Delete"></i>
                    </div>
                    
                  </div>
                  <div class="almarai-regular text-title">{{ row.title }}</div>
                    <div class="row pt-1">
                      <div class="col-auto px-2 content-center">
                        <i class="fa-solid fa-location-dot gray-color"></i>
                      </div>
                      <div class="col p-0 fontGray-73 content-center">
                        <div class="d-flex">
                          {{ row.City?.name }}
                          <span class="mx-1">{{ row.Neighborhood?.name }}</span>
                        </div>
                      </div>
                    </div>

                    <hr class="border-color-w">
                    <div class="row end-card space">
                      <div class="col content-center">
                        <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                        <span class="green-color-F almarai-bold">{{ row.price }}</span>
                      </div>
                      <div class="col-auto content-center" v-if="row.roomsCount && row.bathrooms">
                        <div class="row">
                          <div class="col-auto content-center">
                            <span> 
                              <img :src="MEDIA_URL + icons.roomsCount.path" 
                                class="max-width-28"
                                alt=""/>
                            </span>
                            <span class="numbers">{{ row.roomsCount }}</span>
                          </div>
                          <div class="col-auto border_Icons">
                            <span>
                              <img :src="MEDIA_URL + icons.bathrooms.path"
                                class="max-width-28"
                                alt=""/>
                            </span>
                            <span class="numbers">{{ row.bathrooms }}</span>
                          </div>
                        </div>
                      </div>
                      <div v-else class="col-auto content-center">
                        <span>
                          <img :src="MEDIA_URL + icons.area.path"
                            class="max-width-28"
                            alt=""/>
                        </span>
                        <span class="numbers">
                          {{ row.area }}
                          <span>{{ $t("areaSymbol") }}</span>
                        </span>
                      </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>

        <div class="row pt-3" v-if="exchanges.length">
          <div class="col-12">
            <h6>
              <img src="/assets/images/icons/shop.png" class="w-24" alt="" />
              <span class="almarai-bold mx-2">{{$t("home.Business_Transfer")}}</span>
            </h6>
            <div class="row pt-3">
              <div class="col-12 col-md-5 col-lg-3 mb-3" v-for="(val,indx) in exchanges" :key="indx">
                <div v-if="val.status == 'rented' || val.status == 'sold'" class="card card-border m-auto">
                  <div class="card-body position-R">
                    <div v-if="val.status == 'available'" class="position-R" @click.prevent="updateStatus(val.id, val.status)">
                      <i class="fa-regular fa-pen-to-square icon_Edit"></i>
                    </div>
                    <div v-if="val.status == 'rented' || val.status == 'sold'" class="position-R" @click.prevent="updateStatus(val.id, val.status)">
                      <i class="fa-regular fa-pen-to-square icon_Edit"></i>
                    </div>
                    <div class="position-R" @click.prevent="deleteExchanges(val.id, index)">
                      <i class="fa-regular fa-trash-can red-color icon_Delete"></i>
                    </div>
                    <swiper
                      v-if="val.ExchangeMedia.length"
                      class="text-center"
                      :modules="[Autoplay, Navigation, Pagination]"
                      :autoplay="{ delay: 2500, disableOnInteraction: false }"
                      :pagination="{ clickable: true }"
                      :navigation="false"
                    >
                      <swiper-slide
                        v-for="(img, ind) in val.ExchangeMedia"
                        :key="ind"
                      >
                        <img
                          :src="MEDIA_URL + img.thumbnail"
                          alt="Slide Image"
                          class="w-100 br-radius"
                        />
                      </swiper-slide>
                    </swiper>
                    <div v-else >
                      <placeHolder />
                    </div>
                    <div class="text-title">
                      {{ val.ExchangeBusiness?.name }}
                    </div>
                    <div class="row pt-1">
                      <div class="col-auto px-2 content-center">
                        <i class="fa-solid fa-location-dot gray-color"></i>
                      </div>
                      <div class="col p-0 fontGray-73 content-center">
                        <div class="d-flex">
                          {{ val.City?.name }}
                          <span class="mx-1">{{ val.Neighborhood?.name }}</span>
                        </div>
                      </div>
                    </div>
                    <hr class="border-color-w" />
                    <div class="row end-card space">
                      <div class="col content-center" v-if="val.price">
                        <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                        <span class="green-color-F almarai-bold">{{val.price}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="card card-border m-auto">
                  <router-link :to="'/businessTransfer/' + val.id +'?propertyType=exchange'">
                    <div class="card-body position-R">
                      
                      <!-- <span class="heart-icon" v-if="val.Favorites && val.Favorites.length" @click.prevent="removeFavorite(val.id, 'singlesProperties', index)">
                        <i class="fa-solid fa-heart orange-Heart"></i>
                      </span>
                      <span  class="heart-icon" v-else @click.prevent="addFavorite(val.id, 'singlesProperties', index)">
                        <i class="fa-solid fa-heart heart"></i>
                      </span> -->
                      <div v-if="val.status == 'available'" class="position-R" @click.prevent="updateStatus(val.id)">
                        <i class="fa-regular fa-pen-to-square icon_Edit"></i>
                      </div>
                      <div class="position-R" @click.prevent="deleteExchanges(val.id, index)">
                        <i class="fa-regular fa-trash-can red-color icon_Delete"></i>
                      </div>
                      <swiper
                        v-if="val.ExchangeMedia.length"
                        class="text-center"
                        :modules="[Autoplay, Navigation, Pagination]"
                        :autoplay="{ delay: 2500, disableOnInteraction: false }"
                        :pagination="{ clickable: true }"
                        :navigation="false"
                      >
                        <swiper-slide
                          v-for="(img, ind) in val.ExchangeMedia"
                          :key="ind"
                        >
                          <img
                            :src="MEDIA_URL + img.thumbnail"
                            alt="Slide Image"
                            class="w-100 br-radius"
                          />
                        </swiper-slide>
                      </swiper>
                      <div v-else >
                        <placeHolder />
                      </div>
                      <div class="text-title">
                        {{ val.ExchangeBusiness?.name }}
                      </div>
                      <div class="row pt-1">
                        <div class="col-auto px-2 content-center">
                          <i class="fa-solid fa-location-dot gray-color"></i>
                        </div>
                        <div class="col p-0 fontGray-73 content-center">
                          <div class="d-flex">
                            {{ val.City?.name }}
                            <span class="mx-1">{{ val.Neighborhood?.name }}</span>
                          </div>
                        </div>
                      </div>
                      <hr class="border-color-w" />
                      <div class="row end-card space">
                        <div class="col content-center" v-if="val.price">
                          <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                          <span class="green-color-F almarai-bold">{{val.price}}</span>
                        </div>
                        <div class="col-auto content-center" v-if="val.roomsCount && val.bathroomsCount">
                          <!-- <div class="row">
                            <div class="col-auto content-center">
                              <span>
                                <img :src="MEDIA_URL+roomsCount.path" 
                                  class="max-width-28" alt=""/>
                              </span>
                              <span class="numbers">{{ val.roomsCount }}</span>
                            </div>
                            <div class="col-auto border_Icons">
                              <span>
                                <img :src="MEDIA_URL+bathrooms.path"
                                  class="max-width-28" alt=""/>
                              </span>
                              <span class="numbers">{{ val.bathroomsCount }}</span>
                            </div>
                          </div> -->
                        </div>
                        <!-- <div v-else class="col-auto content-center">
                          <span> 
                            <img :src="MEDIA_URL+area.path" class="max-width-28" alt=""/>
                            </span>
                          <span class="numbers">
                            {{ val.area }}
                          <span>{{ $t("areaSymbol") }}</span></span>
                        </div> -->
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!rows.length" class="row justify-content-center">
          <div class="col text-center">
            <div class="row">
              <div class="col">
                <div><img src="/assets/images/Frame.png" alt=""></div>
                <h2>{{$t('advertisements.title_2')}}</h2>
                <h6 class="almarai-regular gray-color">{{$t('advertisements.title_3')}} <br> {{$t('advertisements.title_4')}}</h6>
              </div>
            </div>
            <div class="row justify-content-center pt-4">
              <div class="col-8 text-center">
                <router-link to="/propertiecreate">
                  <button class="btn-black form-control font-24">{{$t('advertisements.button')}}</button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- begin:modal property Status change -->
  <button type="button" id="btn_statusChange" class="hidden-fileds" data-bs-toggle="modal" data-bs-target="#statusChange"></button>

  <!-- Modal -->
  <div class="modal fade" id="statusChange" tabindex="-1" aria-labelledby="statusChangeLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- <div class="modal-header">
          <h1 class="modal-title fs-5" id="statusChangeLabel">Modal title</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div> -->
        <div class="modal-body proStatuschange">
          <h5>{{$t('changingStatus')}}</h5>
          <h6>{{$t('select_PropertyStatus')}}</h6>
          <div class="row proStatus" v-if="!currentStatus =='rented' || !currentStatus =='sold'">
            <div class="col">
              <div :class="(status == 'sold')? 'card statusSeleted' : 'card'">
                <div class="card-body">
                  <label for="sold" class="show">
                    <input class="form-check-input radio hidden-fileds" v-model="status" 
                      type="radio" value="sold" name="radioDefault" id="sold">
                    <div class="row justify-content-center">
                      <div class="col">
                        <div class="almarai-bold">{{$t('btn_Sold')}}</div>
                      </div>
                      <div class="col-auto content-center">
                        <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                        <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                      </div>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="row proStatus" v-if="!currentStatus =='rented' || !currentStatus =='sold'">
            <div class="col">
              <div :class="(status == 'rented')? 'card statusSeleted' : 'card'">
                <div class="card-body">
                  <label for="rented" class="show">
                    <input class="form-check-input radio hidden-fileds" v-model="status" 
                      type="radio" value="rented" name="radioDefault" id="rented">
                    <div class="row justify-content-center">
                      <div class="col">
                        <div class="almarai-bold">{{$t('btn_Rented')}}</div>
                      </div>
                      <div class="col-auto content-center">
                        <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                        <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                      </div>
                    </div>
                  </label>  
                </div>
              </div>
            </div>
          </div>
          <div class="row proStatus">
            <div class="col">
              <div :class="(status == 'underReview')? 'card statusSeleted' : 'card'">
                <div class="card-body">
                  <label for="underReview" class="show">
                    <input class="form-check-input radio hidden-fileds" v-model="status" 
                      type="radio" value="underReview" name="radioDefault" id="underReview">
                    <div class="row justify-content-center">
                      <div class="col">
                        <div class="almarai-bold">{{$t('btn_underReview')}}</div>
                      </div>
                      <div class="col-auto content-center">
                        <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                        <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                      </div>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="row py-4 justify-content-center">
            <div class="col-11 col-md-7 btn-green" @click.prevent="updateCompletionStatus"> 
              {{$t('send')}}
            </div>
            <!-- <div v-else class="text-center">
              <loader />
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end:modal property Status change -->
  <!-- begin:form Success -->
    <div class="modal bg-modal" tabindex="-1" id="formSuccess">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row justify-content-center py-2">
              <div class="col-12 text-center">
                <img src="/assets/images/icons/tick-circle-gold.png" class="circleGold" alt="">
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="font-24 almarai-bold text-center mb-1">{{$t('propertyStatuschanged')}}</div>
                <!-- <div class="text-center fonttext-14 gray-color almarai-regular"></div> -->
              </div>
            </div>
            <div class="row py-3 justify-content-center">
              <div class="col-11 col-md-8 btn-green text-center" @click.prevent="closeForm">
                {{$t('returnMyads')}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end:form Success -->
</template>
<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
</script>
<script>
import { mapGetters } from 'vuex';
// import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
// import { Pagination, Navigation } from "swiper/modules";
export default {
  name: "advertisements",
  // setup(){
  //   return{
  //     Pagination,
  //     Navigation,
  //   }
  // },
  data(){
    return {
      hasError: false,
      message: "",
      isLoading: false,
      rows:[],
      icons: {},
      items: {},
      exchanges: [],
      userLang: 'ar',
      status: "",
      propertyId: null,
      loading: false,
      currentStatus: "",
    }
  },
  components: { Swiper, SwiperSlide },
  computed:{
    ...mapGetters(['MEDIA_URL'])
  },

  methods: {
    getUserProperties(){
      this.isLoading = true;
      this.hasError = false;
      this.$http.get("/api/properties/myProperties").then(res => {
        // console.log(res);
        this.isLoading = false;
        this.rows = res.data.myProperties;
        this.icons = res.data.countedIcons;
        this.items = res.data.statusChoices;
      }).catch (err => {
        // console.log(err);
        this.isLoading = false;
        this.message = this.$globalError(err);
        this.hasError = true;
        scrollTo({top:0, behavior:'smooth'});
      });
    },

    exchangeList(){
      this.$http.get('/api/exchanges/list?forMe=1').then(res => {
        // console.log(res);
        this.exchanges = res.data.rows
      }).catch(err => {
        this.isLoading = false;
        this.message = this.$globalError(err);
        this.hasError = true;
        scrollTo({top:0, behavior:'smooth'});
      });
    },

    deleteImg(id, index){
      swal({
        title: this.$t('confirm_title'),
        // text: "You will not be able to recover this imaginary file!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: this.$t('confirmButtonText'),
        cancelButtonText: this.$t('cancelButtonText'),
        closeOnConfirm: false
      },()=> this.deleteMedia(id, index));
    },
    deleteMedia(id, index){
      this.$http.delete("/api/properties/delete/"+id).then(res => {
        this.rows.splice(index, 1);
        swal(this.$t('confirmMessage'));
      })
    },

    deleteExchanges(id, index){
      swal({
        title: this.$t('confirm_title'),
        // text: "You will not be able to recover this imaginary file!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: this.$t('confirmButtonText'),
        cancelButtonText: this.$t('cancelButtonText'),
        closeOnConfirm: false
      },()=> this.deleteMediaExchanges(id, index));
    },
    deleteMediaExchanges(id, index){
      this.$http.delete("/api/exchanges/delete/"+id).then(res => {
        this.exchanges.splice(index, 1);
        swal(this.$t('confirmMessage'));
      }).catch(err => {
        this.message = this.$globalError(err);
        this.hasError = true;
        scrollTo({top:0, behavior:'smooth'});
      })
    },

    updateStatus(id, stat){
      this.propertyId = id;
      this.currentStatus = stat;
      document.getElementById('btn_statusChange').click();
    },

    updateCompletionStatus(){
      // this.loading = true;
      this.$http.put('/api/properties/updateCompletionStatus/'+this.propertyId,{
        status: this.status,
      }).then(res => {
        document.getElementById('btn_statusChange').click();
        document.getElementById('formSuccess').style.display ='block';
        this.loading = false;
      }).catch(err => {
        this.loading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        document.getElementById('btn_statusChange').click();
        window.scroll(0,0);
      })
    },

    closeForm(){
      document.getElementById('formSuccess').style.display ='none';
    },
  },

  created(){
    this.getUserProperties();
    this.exchangeList();
    this.userLang = localStorage.getItem('lang') ??  'ar';
    window.scrollTo({top:0, behavior:'smooth'});
  },
}
</script>
